module.exports = __webpack_public_path__ + "static/media/rogue5.bef87038.jpg";